import { MoveGenerator } from '../../jscaip/AI/AI';
import { FourStatePiece } from '../../jscaip/FourStatePiece';
import { TriangularGameState } from '../../jscaip/state/TriangularGameState';
import { SaharaMove } from './SaharaMove';
import { SaharaRules } from './SaharaRules';
export class SaharaMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const moves = [];
        const board = node.gameState.getCopiedBoard();
        const player = node.gameState.getCurrentPlayer();
        const startingCoords = SaharaRules.get().getStartingCoords(node.gameState, player);
        for (const start of startingCoords) {
            const neighbors = TriangularGameState.getEmptyNeighbors(board, start, FourStatePiece.EMPTY);
            for (const neighbor of neighbors) {
                const newMove = SaharaMove.from(start, neighbor).get();
                board[neighbor.y][neighbor.x] = board[start.y][start.x];
                board[start.y][start.x] = FourStatePiece.EMPTY;
                moves.push(newMove);
                const upwardTriangle = (neighbor.y + neighbor.x) % 2 === 0;
                if (upwardTriangle) {
                    const farNeighbors = TriangularGameState.getEmptyNeighbors(board, neighbor, FourStatePiece.EMPTY);
                    for (const farNeighbor of farNeighbors) {
                        if (farNeighbor.equals(start) === false) {
                            const farMove = SaharaMove.from(start, farNeighbor).get();
                            board[farNeighbor.y][farNeighbor.x] = board[neighbor.y][neighbor.x];
                            board[neighbor.y][neighbor.x] = FourStatePiece.EMPTY;
                            moves.push(farMove);
                            board[neighbor.y][neighbor.x] = board[farNeighbor.y][farNeighbor.x];
                            board[farNeighbor.y][farNeighbor.x] = FourStatePiece.EMPTY;
                        }
                    }
                }
                board[start.y][start.x] = board[neighbor.y][neighbor.x];
                board[neighbor.y][neighbor.x] = FourStatePiece.EMPTY;
            }
        }
        return moves;
    }
}
